export default function localeString(number){
    return number?.toLocaleString("en-IN", {minimumFractionDigits:0,maximumFractionDigits:2})
}